import { createSelector } from 'redux-starter-kit';
import _property from 'lodash/property';

export const getOwnProps = (_, ownProps) => ownProps;

export const getIntlFromProps = createSelector(
  [getOwnProps],
  _property('intl')
);
